import Index from "../../Modules/Bank/Index";
import * as auth from "../../services/auth";

export default [
    {
        name: 'banks',
        path: '/admins/banks',
        component: Index,
        beforeEnter(to, from, next) {
            if (!auth.isLoggedIn()) {
                next('/')
            } else {
                next();
            }
        }
    },
]
